import { render } from "./LetsinIndex.vue?vue&type=template&id=624d6472"
import script from "./LetsinIndex.vue?vue&type=script&lang=js"
export * from "./LetsinIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__